module.exports = __webpack_public_path__ + "static/media/mastercard.29339041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment-methods/mastercard.png
// module id = 580
// module chunks = 0